<template>
	<!--v-click-outside="$emit('clickOutside')"-->
	<div class="keypad">
		<div :class="!smaller ? 'flex-row' : 'flex-row small'">
			<icon-component v-if="smaller" iconName="close" class="close-btn" @click="$emit('close')" />
			<button @click="$emit('clickOnKey',1)" class="number">1</button>
			<button @click="$emit('clickOnKey',2)" class="number">2</button>
			<button @click="$emit('clickOnKey',3)" class="number">3</button>
			<button @click="$emit('clickOnKey',4)" class="number">4</button>
			<button @click="$emit('clickOnKey',5)" class="number">5</button>
			<button @click="$emit('clickOnKey',6)" class="number">6</button>
			<button @click="$emit('clickOnKey',7)" class="number">7</button>
			<button @click="$emit('clickOnKey',8)" class="number">8</button>
			<button @click="$emit('clickOnKey',9)" class="number">9</button>
			<button v-if="!keyboardToggle && !dot" style="visibility: hidden" class="number">.</button>
			<button @click="$emit('clickOnKey',0)" class="number">0</button>
			<button v-if="dot" @click="$emit('clickOnKey','.')" class="number">.</button>
			<button v-if="keyboardToggle" :style="{visibility: dot ? 'visible' : 'hidden'}" @click="$emit('toggleKeyboardType', 'keyboard')" class="number">ABC</button>
			<button @click="$emit('clear')" class="number clear">
				<icon-component iconName="backSpaceBlk" />
			</button>
		</div>
	</div>
</template>

<script>
import iconComponent from "@/components/_shared/Icon.vue";

export default {
	name: "Keypad",
	components: {iconComponent},
	props: {
		keyboardToggle: {
			default: false,
			required: false,
			type: Boolean
		},
		dot: {
			default: true,
			required: false,
			type: Boolean
		},
		smaller: {
			default: false,
			required: false,
			type: Boolean
		}
	},
	data() {
		return {}
	},
	methods: {}
}
</script>
<style lang="less" scoped>
.keypad {
  z-index: 1112;
  width: 396px;
  max-width: 100%;
  height: auto;
  box-sizing: border-box;
  border-radius: 12px;
  background: #f5f9fc;

  .flex-row {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px 5px;
    padding: 22px 15px;

    .number {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: none;
      height: clamp(44px, 7vh, 63px);
      height: clamp(44px, 7dvh, 63px);
      margin: 0;
      border: 0;
      border-radius: 2px;
      background: white;
      font-size: clamp(20px, 3vw, 32px);
      font-weight: 600;
      line-height: 1;
      text-align: center;
      letter-spacing: .291225px;
    }

    .clear { background: transparent; }

    .number:active {
      background: #f8e9e9;
      box-shadow: 0 2px 0 white;
    }
  }

  .flex-row.small {
    position: relative;
    padding: 44px 8px 8px;

    .close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
    }

    .number { height: 44px; }
  }
}
</style>
